module.exports = __webpack_public_path__ + "img/CHEVRON_LEFT.70ebaf07.svg";